import * as React from 'react';
import {SchemaNavigatorProps} from './useSchemaNavigator';

import '../css/schemanavigator.css';
import {useSearchBar} from './SearchBar';
import {SchemaNavigator} from './SchemaNavigator';

export const StandaloneSchemaNavigator: React.FC<SchemaNavigatorProps> = ({
    schemaProvider,
    handleError,
    showMetamodel,
    clientRql,
}) => {
    const {
        textSearch: entityTypeTextSearch,
        setTextSearch: setEntityTypeTextSearch,
    } = useSearchBar();

    const {
        textSearch: relationsAndAttributesTextSearch,
        setTextSearch: setRelationsAndAttributesTextSearch,
    } = useSearchBar();

    const {
        textSearch: linkedEntityTypeTextSearch,
        setTextSearch: setLinkedEntityTypeTextSearch,
    } = useSearchBar();

    return (
        <SchemaNavigator
            {...{
                schemaProvider,
                showMetamodel,
                clientRql,
                entityTypeTextSearch,
                setEntityTypeTextSearch,
                relationsAndAttributesTextSearch,
                setRelationsAndAttributesTextSearch,
                linkedEntityTypeTextSearch,
                setLinkedEntityTypeTextSearch,
                handleError,
            }}
        />
    );
};
